var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 646.6",
    width: "1em",
    height: "1em",
    enableBackground: "new 0 0 1000 646.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme",
    transform: "translate(1010, -20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fill: "currentcolor",
    transform: "scale(-1,1)",
    d: "M716.6,20L1015,343.3L716.6,666.6l-24.7-22.8l259.5-281.2H15V329h941.1L691.9,42.8L716.6,20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.769d79ebe0c8353a7deb2dcb74da96fe.svg";
export { ForwardRef as ReactComponent };